<template>
  <div class="delete-account">
    <div class="px-[30px]">
      <a-alert
        :message="
          type !== DELETE_TYPE.TEAM
            ? $t('zhang-hao-zhu-xiao-hou-bu-ke-hui-fu-qing-jin-shen-cao-zuo')
            : $t(
                'tuan-dui-zhang-hao-zhu-xiao-hou-tuan-dui-ji-cheng-yuan-ge-ren-kong-jian-de-nei-rong-jiang-shan-chu-bu-ke-hui-fu-qing-jin-shen-cao-zuo'
              )
        "
        type="warning"
        show-icon
      />
    </div>
    <a-spin :spinning="loading">
      <div class="min-h-[300px]">
        <CheckInfo
          v-if="steps === 'check' && !loading && type !== DELETE_TYPE.TEAM"
          :list="superList"
          @cancel="cancel"
          @set="changeStep"
        />
        <CheckTeamInfo
          v-if="steps === 'check' && !loading && type === DELETE_TYPE.TEAM"
          @cancel="cancel"
          @set="changeStep"
        />
        <CheckForm
          v-if="steps === 'code'"
          :type="type"
          :data="
            type === DELETE_TYPE.PERSON
              ? phone
              : isGlobalVersion()
              ? userInfo?.email_address
              : userInfo?.phone_number
          "
          @cancel="cancel"
          @set="changeStep"
        />
        <div v-if="steps === 'submit'">
          <div class="mt-[30px] mb-[272px] text-font-1 text-center font-bold">
            {{ $t('zhu-ce-zhang-hu-hou-bu-ke-hui-fu') }}，{{
              $t('ru-you-qi-ta-xu-qiu-ke')
            }}
            <a @click="openCustomer">{{ $t('lian-xi-ke-fu') }}</a>
            {{ $t('jie-jue') }}，{{ $t('que-ren-shi-fou-zhu-xiao') }}
          </div>
          <div class="delete-modal-footer">
            <a-button type="primary" ghost @click="cancelAccount">
              {{ $t('ji-xu-zhu-xiao') }}
            </a-button>
            <a-button type="primary" @click="cancel">
              {{ $t('zan-bu-zhu-xiao') }}
            </a-button>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script setup lang="ts">
import CheckForm from './checkForm.vue'
import CheckInfo from './checkInfo.vue'
import CheckTeamInfo from './checkTeamInfo.vue'
import { deleteAccount, deleteTeamAccount, getUserAccountList } from '@/api'
import { USER_LEVEL_KEY } from '~/api/interface'
import { USER_ADMIN } from '~/constants'
import type { LoginInfo } from '~/api/interface/auth'
import { DELETE_TYPE } from '~/utils/constant'
const { $t } = useNuxtApp()

type StepType = 'check' | 'code' | 'submit' // 确认/验证码/提交

interface DeleteProps {
  cancel: () => void
  logout: () => void
  type: DELETE_TYPE
}
const props = defineProps<DeleteProps>()

const steps = ref<StepType>('check')

const superList = ref<LoginInfo[]>([])
const loading = ref(false)
const phone = ref('')
const code = ref()
const userInfo = useUserInfo()

const cancelAccount = async () => {
  const params = {
    sms_code: code.value,
  }

  props.type === DELETE_TYPE.PERSON
    ? await deleteAccount(params)
    : await deleteTeamAccount({
        org_id: userInfo.value?.organization_id,
      })

  message.success(
    props.type === DELETE_TYPE.PERSON
      ? $t('zhu-xiao-cheng-gong')
      : $t('tuan-dui-yi-jie-san')
  )

  trackEvent(TRACK_EVENT.LOG_OFF_ACCOUNT_SUCCESS)

  logoutInfo()
}

// 退出登录
const logoutInfo = () => {
  props.cancel()
  props.logout()
}

const changeStep = (step: StepType, sms_code?: number) => {
  steps.value = step

  if (sms_code) {
    code.value = sms_code
  }
}

const openCustomer = () => {
  openCustomerService()
}

const fetchAccountList = async () => {
  loading.value = true
  const res = await getUserAccountList()
  if (!res.code && res.data) {
    phone.value = isGlobalVersion()
      ? res.data[0].email_address
      : res.data[0].phone_number
    superList.value = res.data.filter(
      (item) =>
        ![
          USER_LEVEL_KEY.PERSONAL,
          USER_LEVEL_KEY.TASTE,
          USER_LEVEL_KEY.PERSONAL_LITE,
        ].includes(Number(item.rights_type)) &&
        Number(item.permission) !== USER_ADMIN.NORMAL
    )
    loading.value = false
  }
}

fetchAccountList()
</script>

<style lang="scss" scoped>
.delete-account {
  @apply text-font-80 pt-[20px] w-full mx-auto;
}
</style>

<style lang="scss">
.delete-account-modal {
  .ant-modal-confirm-content {
    max-width: 100% !important;
  }
}
.delete-modal-footer {
  @apply p-[16px] flex-y-center justify-center mt-[16px] gap-[20px];
  border-top: 1px solid var(--back-4);
}
</style>
